// extracted by mini-css-extract-plugin
export default {"Header":"DialogHeader_Header__fs+dC","CloseBtn":"DialogHeader_CloseBtn__kyjWA"};